import { type Period, periodStartDate } from "./period";

/** Latest live version at the cutoff; equal effective dates use updatedAt, then lowest id (preserving primary-key order ties). */
export function versionAt<T extends { readonly effectiveFrom: string; readonly updatedAt?: string; readonly id?: string }>(
  rows: readonly T[], ymd: string,
): T | null {
  let selected: T | null = null;
  for (const row of rows) {
    if (row.effectiveFrom > ymd) continue;
    if (!selected || row.effectiveFrom > selected.effectiveFrom) {
      selected = row;
      continue;
    }
    if (row.effectiveFrom !== selected.effectiveFrom) continue;
    // Legacy callers omit update timestamps; preserve their existing date-only behavior.
    const laterUpdate = row.updatedAt !== undefined && selected.updatedAt !== undefined && row.updatedAt > selected.updatedAt;
    const earlierId = row.updatedAt === selected.updatedAt && (row.id ?? "") < (selected.id ?? "");
    if (laterUpdate || earlierId) selected = row;
  }
  return selected;
}

export function versionInForce<T extends { readonly effectiveFrom: string; readonly updatedAt?: string; readonly id?: string }>(
  rows: readonly T[], period: Period, timeZone: string,
): T | null {
  return versionAt(rows, periodStartDate(period, timeZone));
}
